import axios, { AxiosError } from "axios";
import {
  Dispatch,
  FormEvent,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";

import { ReactComponent as EyeClose } from "../../assets/images/eyeClose.svg";
import { ReactComponent as EyeOpen } from "../../assets/images/eyeOpen.svg";
import { url } from "../../controllers";
import { licenseCheck } from "../../controllers/license";
import { selfUserAuth } from "../../controllers/users";
import { cookies } from "../../utils/cookies";
import { toastify } from "../common/notification";

export type UserStateT = {
  id: string;
  email: string;
  name: string;
  role: string;
  granted_organization: string[];
  authToken: string;
};

function Auth({ setUser }: { setUser: Dispatch<SetStateAction<UserStateT>> }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const searchParams = useLocation();
  const history = useHistory();

  const apiErrorHandler = (error: AxiosError<{ message: string }>) => {
    let errorMsg = "Something went wrong";
    if (error.response?.data.message) {
      errorMsg = error.response.data.message;
    }

    toastify("failure", errorMsg);
  };

  useEffect(() => {
    const token = searchParams.search.split("=")[1];
    console.log("token", token);
    const from = (searchParams.state as any)?.from || "/dashboard";

    console.log("from", from);
    if (token) {
      selfUserAuth(token)
        .then((response) => {
          const resp = response.data;
          console.log("res", resp);
          if (response.status === 201) {
            cookies.set("token", resp.data.token);

            setUser({
              id: resp.data.user._id,
              email: resp.data.user.email,
              name: resp.data.user.name,
              role: resp.data.user.role,
              granted_organization: resp.data.user.granted_organization,
              authToken: resp.data.token,
            });
            console.log("ud", {
              id: resp.data.user._id,
              email: resp.data.user.email,
              name: resp.data.user.name,
              role: resp.data.user.role,
              granted_organization: resp.data.user.granted_organization,
              authToken: resp.data.token,
            });

            if (resp.data.user.role) {
              licenseCheck()
                .then((licenseData: { valid: boolean }) => {
                  if (licenseData.valid) {
                    history.push("/flow-Orchestration");
                  } else {
                    history.push("/get-license");
                  }
                })
                .catch(() => {
                  history.push("/license-expired");
                });
            }
            // history.push('/update-password')
          } else {
            toastify("failure", "Invalid Username and Password");
            history.push("/");
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log("err", err);
          if (axios.isAxiosError(err) && err.response?.status === 404) {
            return;
          }
          setIsLoading(false);
        });
    }
  }, []);

  const handleLogin = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if ([username, password].includes("")) return;

    setIsLoading(true);

    const postUrl = `${url}/login`;

    const requestOptions = {
      email: username,
      password,
      // since same api is consumed by orchestrator and studio for developer-login, added a key named requestId for orchestrator to validate the request comes from orchestrator
      requestId: new Date().getTime(),
    };

    axios
      .post(postUrl, requestOptions)
      .then((response) => {
        if (response.status === 201) {
          // localStorage.setItem("token", response.data.token);
          cookies.set("token", response.data.token);

          setUser({
            id: response.data.user.id,
            email: response.data.user.email,
            name: response.data.user.name,
            role: response.data.user.role,
            granted_organization: response.data.user.granted_organization,
            authToken: response.data.token,
          });

          // if (response.data.user.first_login === true) {
          //   history.push({
          //     pathname: "/update-password",
          //     state: response.data.user._id,
          //   });
          // } else
          if (response.data.user.role === "super_admin") {
            licenseCheck()
              .then((licenseData: { valid: boolean }) => {
                if (licenseData.valid) {
                  history.push("/dashboard");
                } else {
                  history.push("/get-license");
                }
              })
              .catch(() => {
                history.push("/license-expired");
              });
          } else if (response.data.user.role === "organization_admin") {
            licenseCheck()
              .then((licenseData: { valid: boolean }) => {
                if (licenseData.valid) {
                  history.push("/organisation");
                } else {
                  history.push("/get-license");
                }
              })
              .catch(() => {
                history.push("/license-expired");
              });
          } else if (response.data.user.role === "agent_admin") {
            licenseCheck()
              .then((licenseData: { valid: boolean }) => {
                if (licenseData.valid) {
                  history.push("/botscreen");
                } else {
                  history.push("/get-license");
                }
              })
              .catch(() => {
                history.push("/license-expired");
              });
          } else {
            licenseCheck()
              .then((licenseData: { valid: boolean }) => {
                if (licenseData.valid) {
                  history.push("/dashboard");
                } else {
                  history.push("/get-license");
                }
              })
              .catch(() => {
                history.push("/license-expired");
              });
          }
          // history.push('/update-password')
        } else {
          toastify("failure", "Invalid Username and Password");
          history.push("/");
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        apiErrorHandler(err);
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          return;
        }
        setIsLoading(false);
      });
  };
  let passwordEyeIcon: JSX.Element | undefined;
  if (password) {
    passwordEyeIcon = showPassword ? <EyeOpen /> : <EyeClose />;
  }

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", flexDirection: "column" }}
    >
      <div
        style={{
          marginTop: "2%",
          width: "450px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1>Sign in to RAPBot</h1>
      </div>
      <div
        style={{
          height: "250px",
          width: "450px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "5%",
          marginLeft: "10%",
        }}
      >
        <form onSubmit={handleLogin} id="login">
          <div style={{ margin: "5%" }}>
            <div>
              <Form.Group className="input">
                <Form.Control
                  placeholder="Email"
                  aria-label="Email"
                  aria-describedby="basic-addon1"
                  onChange={(e) => setUsername(e.target.value)}
                  name="username"
                  id="username"
                />
              </Form.Group>
              <Form.Group className="input">
                <div style={{ position: "relative" }}>
                  <Form.Control
                    placeholder="Password"
                    aria-label="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    onChange={(e) => setPassword(e.target.value)}
                    aria-describedby="basic-addon1"
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {passwordEyeIcon}
                  </span>
                </div>
              </Form.Group>
            </div>
            <div style={{ display: "flex" }}>
              <Button
                className="button white"
                size="lg"
                type="submit"
                style={{
                  width: "88%",
                  marginLeft: "1%",
                  padding: "3%",
                  marginTop: "3%",
                }}
              >
                {isLoading ? (
                  <Spinner animation="border" variant="primary" />
                ) : (
                  "Sign in"
                )}
              </Button>
            </div>
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: "11%",
                marginTop: "3px",
              }}
            >
              <a href="/forget-password" style={{ color: "#3f4254" }}>
                Forgot password?
              </a>
            </div>
          </div>
        </form>
      </div>
    </Container>
  );
}

export default Auth;
